export default "__VITE_ASSET__DOVPRlCR__"